import type { Article } from "./types";

export const qrCodeWeddingInvitation: Article = {
  slug: "qr-code-wedding-invitation",
  published: true,
  publishedAt: "2026-10-27",
  updatedAt: "2026-10-27",
  title: {
    ro: "Cod QR pentru invitația de nuntă și darul la masă",
    en: "QR code for your wedding invitation and table gift",
  },
  summary: {
    ro: "Cum folosești un cod QR pe invitațiile tipărite sau pe meniurile de la sală pentru confirmarea prezenței și oferirea darului online.",
    en: "How to use a QR code on printed invitations or table menus for RSVP confirmation and online gift contributions.",
  },
  body: {
    ro: [
      { t: "h2", text: "Unde poți folosi codul QR al evenimentului" },
      {
        t: "p",
        text: "Link-ul paginii tale de eveniment (de forma wedistar.com/@nume-eveniment) sau link-ul scurt al evenimentului poate fi transformat într-un cod QR pentru tipar.",
      },
      {
        t: "ul",
        items: [
          "Pe invitația fizică tipărită, pentru ca invitații să confirme prezența în 30 de secunde.",
          "Pe cartonașele de pe mese în seara evenimentului, pentru oferirea darului cu cardul.",
          "La panoul de primire de la intrarea în sală, alături de așezarea la mese.",
        ],
      },
      { t: "h2", text: "Cum funcționează în seara evenimentului" },
      {
        t: "p",
        text: "Cu o zi înainte de eveniment, pagina publică promovează automat butonul „Oferă darul” în secțiunea principală dacă lista de cadouri și plicul digital sunt active. Invitații scanează codul QR cu camera telefonului și pot contribui imediat prin Apple Pay, Google Pay sau card bancar.",
      },
    ],
    en: [
      { t: "h2", text: "Where you can use your event QR code" },
      {
        t: "p",
        text: "Your event page link (such as wedistar.com/@event-slug) or event short link can be turned into a print-ready QR code.",
      },
      {
        t: "ul",
        items: [
          "On printed invitations so guests can confirm attendance in 30 seconds.",
          "On table cards on the night of the event for card gift contributions.",
          "On the welcome board at the venue entrance alongside the seating chart.",
        ],
      },
      { t: "h2", text: "How it works on the night of the event" },
      {
        t: "p",
        text: "Starting one day before the event, the public page automatically promotes the “Send a gift” button in the hero section when your gift registry and digital envelope are active. Guests scan the QR code with their phone camera and can contribute right away via Apple Pay, Google Pay or bank card.",
      },
    ],
  },
};
